import { gql } from '@efficiently/client-core-graphql-models';

export const DRAG_PLAN_PAGE = gql(`
	mutation DragPlanPage($pageIds: [String!]!) {
		dragPlanPage(pageIds: $pageIds)
	}
`);
